<script>
import Component from '~/sites/shop/pages/passwordForgotten'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/zapomenute-heslo',
      en: '/forgotten-password',
      sk: '/zabudnute-heslo',
    },
  },
}
</script>
